import dayjs from 'dayjs';
import 'dayjs/locale/ko';

export const formatCurrentTime = () => {
  return dayjs().format('A hh:mm');
};
